export default function EmBreve() {
  const eventosEmBreve = [
    {
      id: 7,
      nome: "nenhum evento em breve",
      banner: "/imagens/preto.png",
      data: "'''",
      local: " ' ' ' "
    },
  ];

  return (
    <div
      className="page-bg"
      style={{ backgroundImage: 'url("/imagens/textura-hexagono-azul.png")' }}
    >
      <div className="page">

        {eventosEmBreve.map((evento) => (
          <div key={evento.id} className="card-em-breve">

            <span className="badge-em-breve">EM BREVE</span>

            <img
              src={evento.banner}
              alt={evento.nome}
              className="card-em-breve-image"
            />

            <h3>{evento.nome}</h3>

            <div className="card-em-breve-info">
              <p>{evento.data}</p>
              <p>{evento.local}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
